export const chartColumns = [
  {
    field: 'expenseCode',
    title: '费用名称',
    width: '120',
    editRender: { name: 'expenseCode' },
  },
  {
    field: 'documentCategories',
    title: '单据类别',
    width: '150',
    editRender: { name: 'documentCategories' },
  },
  {
    field: 'outboundType',
    title: '出库类型',
    width: '150',
    editRender: { name: 'outboundType' },
  },
  {
    field: 'isContainer',
    title: '是否集装箱',
    width: '140',
    editRender: { name: 'isContainer' },
  },
  {
    field: 'isScattered',
    title: '是否零散',
    width: '140',
    editRender: { name: 'isScattered' },
  },
  {
    field: 'dedicatedLine',
    title: '专线',
    width: '140',
    editRender: { name: 'dedicatedLine' },
  },
  {
    field: 'pricingStandard',
    title: '计价标准',
    width: '140',
    editRender: { name: 'pricingStandard' },
  },
  {
    field: 'billingClassCode',
    title: '计费类别',
    width: '140',
    editRender: { name: 'billingClassCode' },
  },
  {
    field: 'pricingUnit',
    title: '计价单位',
    width: '140',
    editRender: { name: 'pricingUnit' },
  },
  {
    field: 'unitPrice',
    title: '单价/元',
    width: '140',
    editRender: { name: 'unitPrice' },
  },
  {
    field: 'lowerTimeLimit',
    title: '时间下限',
    width: '140',
    editRender: { name: 'lowerTimeLimit' },
  },
  {
    field: 'upperTimeLimit',
    title: '时间上限',
    width: '140',
    editRender: { name: 'upperTimeLimit' },
  },
  {
    field: 'lowerWeightLimit',
    title: '重量下限',
    width: '140',
    editRender: { name: 'lowerWeightLimit' },
  },
  {
    field: 'upperWeightLimit',
    title: '重量上限',
    width: '140',
    editRender: { name: 'upperWeightLimit' },
  },
  {
    field: 'commodityClassificationCode',
    title: '商品分类',
    width: '140',
    editRender: { name: 'commodityClassification' },
  },
  {
    field: 'goodsTypeCode', //
    title: '商品名称',
    width: '140',
    editRender: { name: 'commodityType' },
  },
  {
    field: 'goodsCategoryCode', //
    title: '商品子类',
    width: '140',
    editRender: { name: 'commodityCategory' },
  },
  {
    field: 'specificationId',
    title: '商品规格',
    width: '140',
    editRender: { name: 'commoditySpecifications' },
  },
  // {
  //   field: 'detailProductItems',
  //   title: '货物分类',
  //   width: '140',
  //   editRender: { name: 'commoditySpecifications' },
  // },
  {
    field: 'packId',
    title: '包装',
    width: '140',
    editRender: {
      name: 'packId',
    },
  },
  {
    field: 'packagingCategory',
    title: '包装类别',
    width: '140',
    editRender: { name: 'packageCategoryName' },
  },
  {
    field: 'isSpecialLibrary',
    title: '是否专库',
    width: '140',
    editRender: { name: 'isSpecialLibrary' },
  },
  {
    field: 'reservoirAreaName',
    title: '库区名称',
    width: '140',
    editRender: { name: 'reservoirArea' },
  },
  {
    field: 'reservoirType',
    title: '库区类型',
    width: '140',
    editRender: { name: 'reservoirType' },
  },
  {
    field: 'remarks',
    title: '备注',
    width: '140',
    editRender: {
      name: 'input',
      type: 'default',
    },
  },
];
